import { imageAssetUrl } from "@/utils/url";
import { BrandLogo } from "./brand-logo";
import { PhoneFrame } from "./phone-frame";
import { BrandingPreviewValues } from "./types";

export function MobileManagedByPreview({
  brandName,
  tagLine,
  profileBio,
  logoUrl,
  distributorName,
}: BrandingPreviewValues) {
  return (
    <PhoneFrame
      className="bg-gradient-to-b from-slate-100 via-white to-white"
      footer={
        <div className="flex items-center gap-2 p-3">
          <div className="flex-1 flex items-center justify-center h-9 rounded-lg border border-stone-200 bg-white text-sm font-medium">
            Call
          </div>
          <div className="flex items-center justify-center size-9 rounded-lg border border-stone-200 bg-white">
            <img
              src={imageAssetUrl("whatsapp.png")}
              alt="WhatsApp"
              className="size-5"
            />
          </div>
        </div>
      }
    >
      <div className="flex flex-col px-4">
        <span className="py-4 font-semibold">Managed by</span>
        <div className="flex flex-col items-center gap-3 pt-12 pb-12 text-center">
          <BrandLogo
            url={logoUrl}
            name={brandName}
            className="size-16 rounded-lg text-lg"
          />
          <div className="flex flex-col">
            <span className="font-semibold">{brandName}</span>
            <span className="text-xs text-stone-500">{tagLine}</span>
          </div>
        </div>
        <div className="flex flex-col gap-4">
          <div className="flex flex-col">
            <span className="text-sm font-semibold">{distributorName}</span>
            <span className="text-xs text-stone-500">
              AMFI registered Mutual Fund Distributor
            </span>
          </div>
          <p className="text-sm whitespace-pre-line break-words line-clamp-[12]">
            {profileBio}
          </p>
        </div>
      </div>
    </PhoneFrame>
  );
}
